import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deleteErrorTitle: {
		id: 'business-categories.services.delete-category.delete-error-title',
		defaultMessage: "We couldn't delete the category",
		description: 'Title in flag message informing the user that deleting the category failed',
	},
	deleteErrorMessage: {
		id: 'business-categories.services.delete-category.delete-error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message when delete fails',
	},
	deleteSuccessTitle: {
		id: 'business-categories.services.delete-category.delete-success-title',
		defaultMessage: 'Category deleted',
		description: 'Title in flag message informing the user that deleting the category succeeded',
	},
	deleteSuccessMessage: {
		id: 'business-categories.services.delete-category.delete-success-message',
		defaultMessage: 'Category has been deleted from your business project.',
		description: 'Flag message when category successfully deleted',
	},
});
